import {
  FormEnumFieldWidget,
  FormFieldWidget,
  ModelFieldType,
  RuntimeEnumerationOption,
  SPI,
  ViewType,
  Widget
} from '@kunlun/dependencies';
import { TIssuingMethod, useProxyDelivery } from '../../../../hooks';
import { Ref, toRef } from 'vue';

type EnumerationValue = boolean | string;

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.Enum,
    model: [
      'deli.aries.seller.SellerDistributionCreateOrderParam',
      'deli.aries.seller.SellerDistributorAuditOrderParam',
      'deli.aries.seller.DeliAriesSellerPurchasingPlan',
      'deli.aries.merchant.DeliAriesMerchantChangeDeliveryAddress',
      'deli.aries.merchant.DeliAriesBuyerPurchasingPlan',
      'deli.aries.seller.DeliAriesSellerSpecialApplyOrder'
    ],
    name: 'deliveryAddressTypeEnum',
    multi: false
  })
)
export class FormEnumAddressTypeFieldWidget extends FormEnumFieldWidget {
  public initialize(props) {
    super.initialize(props);
    // this.setComponent(ProxyDelivery);
    return this;
  }

  @Widget.Reactive()
  selectOptions: RuntimeEnumerationOption[] = [];

  @Widget.Reactive()
  protected get options(): RuntimeEnumerationOption[] {
    return this.selectOptions;
  }

  watchProxyMethod(key: string, value: string) {
    console.log('watchProxyMethod', key, value);
    if (value) {
      const { addressTypeOptions, deliveryAddressTypeEnum } = useProxyDelivery(
        toRef(this.formData, key) as Ref<TIssuingMethod>
      );
      this.selectOptions = addressTypeOptions.value;
      if (this.selectOptions.every((option) => option.value !== this.value)) {
        this.setValue(deliveryAddressTypeEnum.value);
      }
    } else {
      this.selectOptions = [];
    }
  }

  @Widget.Watch('formData.ariesIssuingMethodEnum')
  protected watchAriesIssuingMethodEnum(value: string) {
    this.watchProxyMethod('ariesIssuingMethodEnum', value);
  }

  // 要货计划的字段：
  // 代发方式 issuingMethod
  @Widget.Watch('formData.issuingMethod')
  protected watchIssuingMethod(value: string) {
    this.watchProxyMethod('issuingMethod', value);
  }


  // 特殊政策：
  // 代发方式 issuingMethod
  @Widget.Watch('formData.issuingMethodEnum')
  protected watchIssuingMethodEnum(value: string) {
    this.watchProxyMethod('issuingMethodEnum', value);
  }

  change(val: EnumerationValue | null | undefined): void {
    super.change(val);
    this.formData.offlineDeliveryAddress = null;
    this.formData.deliveryAddressCopy = null;
    Object.assign(this.formData.deliveryAddress as any, {
      address: {
        street2: '',
        countryCode: '',
        countryName: '',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        districtName: '',
        districtCode: '',
        streetCode: '',
        streetName: ''
      },
      // addressId: '',
      contactMan: '',
      contactPhone: '',
      detailAddress: ''
      // id: ''
    });
  }
}
